interface Window {
	webkitAudioContext: typeof AudioContext;
}
export class AudioContextAdapter {
	private static instance: AudioContextAdapter | null = null;
	private audioContext: AudioContext;
	private masterGain: GainNode;

	private constructor(masterVolumeLevel = 1) {
		this.audioContext = new (
			window.AudioContext || (window as unknown as Window).webkitAudioContext
		)();
		this.masterGain = this.audioContext.createGain();
		this.masterGain.gain.value = masterVolumeLevel;
		this.masterGain.connect(this.audioContext.destination);
	}

	/**
	 * Singleton access to the instance of the AudioContextAdapter.
	 */
	static getInstance(masterVolumeLevel?: number): AudioContextAdapter {
		if (!AudioContextAdapter.instance) {
			AudioContextAdapter.instance = new AudioContextAdapter(masterVolumeLevel);
		}
		return AudioContextAdapter.instance;
	}

	getAudioContext(): AudioContext {
		return this.audioContext;
	}

	getMasterGain(): GainNode {
		return this.masterGain;
	}

	setMasterVolume(volume: number) {
		this.masterGain.gain.setValueAtTime(volume, this.audioContext.currentTime);
	}
}
